import React, { Component, Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { active, deactive, authorizate } from "./loginSlice";
import { Container, Button, Form, FormControl, Stack } from "react-bootstrap";
import { loginUser } from "./loginApi";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { useEffect } from "react";
import { current } from "@reduxjs/toolkit";

export function Login(props) {
  const log = useSelector((state) => state.login);
  let navigate = useNavigate();
  useEffect(() => {
    if (log.token) {
      return navigate("/control");
    }
  });
  const dispatch = useDispatch();
  const [cred, setCred] = useState({ username: "", password: "" });
  return (
    <Fragment>
      <div className="mt-5">
        <div className="col-md-6 mx-auto vstack gap-3">
          <h4 className="fs-3 navbar-brand text-center">Mancore</h4>
          <form gap={3}>
            <div className="mx-auto vstack gap-3">
              <div>
                <input
                  name="username"
                  placeholder="Логин"
                  type="text"
                  id="usernameId"
                  className="form-control"
                  value={cred.username}
                  onChange={(e) =>
                    setCred({ ...cred, username: e.target.value })
                  }
                />
                <div className="invalid-feedback"></div>
              </div>
              <div>
                <input
                  name="password"
                  placeholder="Пароль"
                  type="password"
                  id="passwordId"
                  className="form-control"
                  value={cred.password}
                  onChange={(e) =>
                    setCred({ ...cred, password: e.target.value })
                  }
                />
                <div className="invalid-feedback"></div>
              </div>
            </div>
          </form>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => dispatch(loginUser(cred))}
          >
            Войти1
          </button>
        </div>
      </div>
    </Fragment>
  );
}

//export default connect(mapStateToProps)(Login);

export default Login;

// We normally do both in one step, like this:
//connect(null, {Login})(Component)
